module.exports = __webpack_public_path__ + "img/5R.fa6603a0.png";